import { useState, useEffect } from 'react';
import ProfileMenu2 from './adminprofilemenu2';
import { useSidebar } from './SidebarContext';

const Navbar = () => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState('');
  const { isSidebarOpen, setIsSidebarOpen } = useSidebar();

  const sidebarWidth = isSidebarOpen ? '15.6rem' : '4.4rem';
  const contentWidth = isSidebarOpen ? 'calc(100% - 15.6rem)' : 'calc(100% - 4rem)';

  // Load admin user details from localStorage on component mount
  useEffect(() => {
    try {
      // Updated to use new localStorage keys
      const adminToken = localStorage.getItem('collegeAdminToken');
      const adminUser = localStorage.getItem('collegeAdminUser');
      const role = localStorage.getItem('collegeAdminRole');

      console.log('Debug - collegeAdminToken:', adminToken);
      console.log('Debug - collegeAdminUser:', adminUser);
      console.log('Debug - collegeAdminRole:', role);

      if (adminToken && role === 'admin') {
        if (adminUser && adminUser !== 'undefined') {
          try {
            const parsedUser = JSON.parse(adminUser);
            console.log('Debug - parsedUser:', parsedUser);
            // Set user with the admin schema structure
            setUser({
              username: parsedUser.username || 'Admin',
              collegeName: parsedUser.collegeName || '',
              email: parsedUser.email || ''
            });
          } catch (parseError) {
            console.error('Error parsing collegeAdminUser JSON:', parseError);
            // If JSON parsing fails, create a default user object
            setUser({ username: 'Admin', collegeName: 'Admin Panel', email: '' });
          }
        } else {
          // If no adminUser data or it's undefined, create a default user object
          console.log('Debug - collegeAdminUser is undefined or null, using default');
          setUser({ username: 'Admin', collegeName: 'Admin Panel', email: '' });
        }
      } else if (!adminToken) {
        console.log('Debug - No college admin token found');
      } else if (role !== 'admin') {
        console.log('Debug - Role is not admin:', role);
      }
    } catch (err) {
      console.error('Error loading admin user data:', err);
      // Don't set error here, just use default
      setUser({ username: 'Admin', collegeName: 'Admin Panel', email: '' });
    }
  }, []);

  // Define alertStyle
  const alertStyle = {
    backgroundColor: '#ffe4e6',
    color: '#dc2626',
    padding: '0.5rem 1rem',
    borderRadius: '0.25rem',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    fontFamily: "'Roboto', sans-serif",
    fontSize: '0.875rem',
  };

  // Define closeButtonStyle
  const closeButtonStyle = {
    background: 'none',
    border: 'none',
    fontSize: '1rem',
    cursor: 'pointer',
    color: '#dc2626',
    fontFamily: "'Roboto', sans-serif",
  };

  return (
    <div
      style={{
        width: contentWidth,
        height: '3.5rem',
        backgroundColor: '#fff',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: '2.2rem',
        paddingLeft: '0',
        position: 'fixed',
        top: 0,
        left: sidebarWidth,
        zIndex: 1000,
        transition: 'all 0.3s ease',
        fontFamily: "'Roboto', sans-serif",
      }}
    >
      <div style={{ marginLeft: '1rem' }}>
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '1.5rem',
            cursor: 'pointer',
            color: '#334155',
            fontFamily: "'Roboto', sans-serif",
          }}
        >
          ☰
        </button>
      </div>

      {error && (
        <div style={alertStyle}>
          <span>{error}</span>
          <button
            style={closeButtonStyle}
            onClick={() => setError('')}
            aria-label="Close"
          >
            ×
          </button>
        </div>
      )}

      {/* RIGHT SIDE: Profile with admin details */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
        {user && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
            <span style={{ 
              fontFamily: "'Roboto', sans-serif", 
              fontWeight: '600',
              fontSize: '0.9rem',
              color: '#334155'
            }}>
              Welcome, {user.username || 'Admin'}
            </span>
            <span style={{ 
              fontFamily: "'Roboto', sans-serif", 
              fontSize: '0.75rem',
              color: '#6B7280'
            }}>
              | {user.collegeName || 'Admin Panel'}
            </span>
          </div>
        )}
        <ProfileMenu2 />
      </div>
    </div>
  );
};

export default Navbar;